import classNames from "classnames";
import styles from "./style.module.scss";

interface CustomBadgeProps {
  title: string | any;
  bg?: string | any;
  textColor?: string | any;
  borderColor?: string | any;
}

const CustomBadge = ({
  title,
  bg = "#ed1c240f",
  textColor = "#ED1C24",
  borderColor = "#ED1C24",
}: CustomBadgeProps) => {
  return (
    <div
      style={{
        borderColor: borderColor,
        backgroundColor: bg,
      }}
      className={classNames(styles.badge_container)}
    >
      <span
        style={{ color: textColor }}
        className={classNames(styles.badge_title)}
      >
        {title}
      </span>
    </div>
  );
};

export default CustomBadge;
